var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.2933116 3.97916685 7.2228024 8.09934458 7.8359375 14.01171875 C8.07633825 21.23298745 7.2784113 25.80165029 2.5625 31.375 C1.9025 32.035 1.2425 32.695 0.5625 33.375 C0.94528626 36.93371598 2.1314483 39.93080515 3.5625 43.1875 C5.78494925 48.65814431 7.65102268 53.53274632 5.4375 59.3125 C3.5625 61.375 3.5625 61.375 1.1875 62.4375 C-2.54409031 62.34865261 -3.77063312 60.93403089 -6.4375 58.375 C-8.01953125 55.2109375 -8.01953125 55.2109375 -9.25 51.75 C-9.66894531 50.60273438 -10.08789062 49.45546875 -10.51953125 48.2734375 C-11.4375 45.375 -11.4375 45.375 -11.4375 43.375 C-13.4175 43.87 -13.4175 43.87 -15.4375 44.375 C-15.60765625 45.33921875 -15.7778125 46.3034375 -15.953125 47.296875 C-16.19546875 48.56015625 -16.4378125 49.8234375 -16.6875 51.125 C-16.91953125 52.37796875 -17.1515625 53.6309375 -17.390625 54.921875 C-18.49767973 58.5735033 -19.40624357 60.11151021 -22.4375 62.375 C-25.5 62.5 -25.5 62.5 -28.4375 61.375 C-32.14079844 56.0282809 -31.90499399 50.72126791 -31.90625 44.46484375 C-31.91386353 43.41978165 -31.92147705 42.37471954 -31.92932129 41.29798889 C-31.94009841 39.0950865 -31.94298514 36.89213312 -31.93847656 34.68920898 C-31.93750215 31.31993759 -31.97919661 27.95292852 -32.0234375 24.58398438 C-32.02864324 22.44010891 -32.03133271 20.29622554 -32.03125 18.15234375 C-32.04764526 17.1470311 -32.06404053 16.14171844 -32.08093262 15.10594177 C-32.01191329 8.12456964 -32.01191329 8.12456964 -29.07080078 4.28662109 C-21.06038535 -1.52846817 -9.1873382 -4.34310533 0 0 Z M-16.4375 16.375 C-16.50955511 18.06108966 -16.52136068 19.75000659 -16.5 21.4375 C-16.49097656 22.35660156 -16.48195312 23.27570313 -16.47265625 24.22265625 C-16.46105469 24.93292969 -16.44945312 25.64320313 -16.4375 26.375 C-13.18406251 25.64381508 -11.44705401 25.1500984 -9.4375 22.375 C-8.62165432 19.31591587 -8.62165432 19.31591587 -8.4375 16.375 C-9.55586224 15.03095225 -9.55586224 15.03095225 -12.4375 15.25 C-15.31913776 15.03095225 -15.31913776 15.03095225 -16.4375 16.375 Z ",
    fill: "#FEFEFE",
    transform: "translate(223.4375,193.625)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.97301056 -0.00571014 1.94602112 -0.01142029 2.94851685 -0.01730347 C4.01972778 -0.01842133 5.09093872 -0.01953918 6.1946106 -0.02069092 C7.8825322 -0.02813828 7.8825322 -0.02813828 9.60455322 -0.03573608 C13.34047041 -0.05038437 17.07634515 -0.05716392 20.81228638 -0.06268311 C23.40059409 -0.06843205 25.98890179 -0.07418981 28.57720947 -0.07995605 C33.31459874 -0.08912792 38.05197094 -0.09542535 42.78936756 -0.09845281 C49.76347528 -0.10293403 56.73738706 -0.12048432 63.7114352 -0.1494534 C69.75025468 -0.17366767 75.78898139 -0.18139677 81.82785416 -0.18312836 C84.397941 -0.18616147 86.96802688 -0.19421201 89.53808212 -0.20731354 C93.12947295 -0.22431556 96.72038367 -0.22250792 100.3117981 -0.21600342 C101.37896057 -0.2252182 102.44612305 -0.23443298 103.54562378 -0.243927 C105.01359909 -0.23557327 105.01359909 -0.23557327 106.51123047 -0.22705078 C107.36036955 -0.22851734 108.20950863 -0.2299839 109.0843792 -0.2314949 C111.93497926 0.22983744 113.29608848 1.16980374 115.38259888 3.14044189 C116.58622472 6.83156115 116.72678178 8.43643141 115.00759888 11.95294189 C113.38259888 14.14044189 113.38259888 14.14044189 112.38259888 15.14044189 C110.85871092 15.24275576 109.33010516 15.27563365 107.80279541 15.28088379 C106.31793137 15.28944901 106.31793137 15.28944901 104.80307007 15.29818726 C103.70799133 15.29930511 102.6129126 15.30042297 101.48464966 15.30157471 C99.76527695 15.30902206 99.76527695 15.30902206 98.01116943 15.31661987 C94.20007742 15.33128575 90.38902703 15.33805071 86.57791138 15.34356689 C83.94093829 15.34931453 81.30396523 15.3550723 78.66699219 15.36083984 C73.8389986 15.37041822 69.01101405 15.37631075 64.18301213 15.3793366 C57.07078478 15.38381808 49.95874954 15.40136738 42.84658062 15.43033719 C36.69296531 15.45453504 30.53942947 15.46227979 24.38576889 15.46401215 C21.76461618 15.46704777 19.14346446 15.47510666 16.52234268 15.48819733 C12.86119122 15.5051773 9.20051158 15.50339713 5.53933716 15.49688721 C4.44830688 15.50610199 3.35727661 15.51531677 2.23318481 15.52481079 C1.2376358 15.51924164 0.24208679 15.51367249 -0.78363037 15.50793457 C-2.08279294 15.51013441 -2.08279294 15.51013441 -3.40820122 15.51237869 C-6.12092261 15.05566995 -6.97522143 14.31246885 -8.61740112 12.14044189 C-9.73018371 8.48415624 -9.93688476 6.82504968 -8.30490112 3.32794189 C-5.73806674 0.00056399 -4.02104945 0.01409887 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(258.6174011230469,201.85955810546875)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.99837867 0.02503652 3.99682699 0.04429156 5.99526978 0.06354141 C9.73821176 0.10272548 13.48025625 0.16212188 17.22280884 0.22818375 C18.33813492 0.23776611 19.453461 0.24734848 20.60258484 0.25722122 C21.63105026 0.28018768 22.65951569 0.30315414 23.71914673 0.32681656 C24.61106216 0.34093582 25.5029776 0.35505508 26.42192078 0.3696022 C29.49691478 0.86519415 31.41595292 1.97429942 33.93765259 3.77505875 C35.35807079 6.61589516 35.25217531 8.62983152 34.93765259 11.77505875 C33.62052917 13.93901443 33.62052917 13.93901443 30.93765259 15.77505875 C27.19706364 16.3839355 23.48149168 16.31049273 19.6991272 16.27676773 C17.97909737 16.28487221 17.97909737 16.28487221 16.22431946 16.29314041 C12.42928356 16.30566057 8.63500133 16.28911479 4.83999634 16.2711525 C2.20731059 16.2713074 -0.42537539 16.27279487 -3.05805969 16.27556229 C-8.57691271 16.27826347 -14.09554812 16.2647957 -19.61434937 16.24161148 C-25.9958124 16.21498893 -32.37691191 16.21325904 -38.75841147 16.22499985 C-44.89765883 16.23577594 -51.03675354 16.22949212 -57.17599297 16.21544456 C-59.78875787 16.21091925 -62.40153349 16.21060264 -65.01429939 16.21450996 C-68.66083044 16.21741055 -72.30676123 16.20096997 -75.95321655 16.17911148 C-77.03953369 16.18361313 -78.12585083 16.18811478 -79.24508667 16.19275284 C-80.2363002 16.18284821 -81.22751373 16.17294357 -82.24876404 16.1627388 C-83.11097596 16.1603089 -83.97318789 16.15787901 -84.86152744 16.15537548 C-87.55311737 15.69025034 -88.41528407 14.91531278 -90.06234741 12.77505875 C-91.08328195 9.79078855 -91.15942537 8.15454531 -90.37484741 5.08755875 C-88.82770316 2.36163792 -87.92490208 1.91711784 -85.06234741 0.77505875 C-82.93502808 0.48985672 -82.93502808 0.48985672 -80.60336304 0.44034195 C-79.7140358 0.41730499 -78.82470856 0.39426804 -77.90843201 0.37053299 C-76.93828659 0.3557843 -75.96814117 0.34103561 -74.96859741 0.32584 C-73.42195656 0.29241753 -73.42195656 0.29241753 -71.84407043 0.25831985 C-68.41693117 0.18936585 -64.98981992 0.13706317 -61.56234741 0.08755875 C-59.80206711 0.05861526 -59.80206711 0.05861526 -58.00622559 0.02908707 C-38.66834321 -0.27956992 -19.33774809 -0.25869762 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(216.06234741210938,279.2249412536621)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.67071584 5.60946559 9.92044767 11.06050801 11.0703125 19.7265625 C11.50265437 28.80574167 8.21622588 37.13807853 2.75 44.3125 C2.193125 45.1375 1.63625 45.9625 1.0625 46.8125 C-5.24338215 53.62966989 -13.75115462 58.24088267 -23.0625 58.8125 C-26.26046981 58.68039798 -26.91373495 58.64876505 -29.25 56.3125 C-31.3301855 50.07194351 -31.39553397 43.60960367 -31.34765625 37.09375 C-31.3462413 36.35040405 -31.34482635 35.60705811 -31.34336853 34.84118652 C-31.33783109 32.49824771 -31.32529091 30.15540927 -31.3125 27.8125 C-31.30747689 26.21093889 -31.30291542 24.60937627 -31.29882812 23.0078125 C-31.28788227 19.10933712 -31.27066196 15.2109355 -31.25 11.3125 C-30.59 11.3125 -29.93 11.3125 -29.25 11.3125 C-29.1571875 9.70375 -29.1571875 9.70375 -29.0625 8.0625 C-28.25 4.3125 -28.25 4.3125 -26.375 2.0625 C-17.97751377 -2.64009229 -8.77229863 -4.55484737 0 0 Z M-14.25 15.3125 C-16.32434732 20.42486781 -16.49424065 24.77580893 -16.375 30.1875 C-16.36597656 30.97125 -16.35695313 31.755 -16.34765625 32.5625 C-16.32428063 34.47930055 -16.28841653 36.39594191 -16.25 38.3125 C-14.93 38.6425 -13.61 38.9725 -12.25 39.3125 C-6.38711093 33.23940702 -6.38711093 33.23940702 -4.1875 25.3671875 C-4.41858414 21.4531999 -4.83471393 19.76145791 -7.5625 16.8125 C-10.31917046 14.98758923 -10.31917046 14.98758923 -14.25 15.3125 Z ",
    fill: "#FEFEFE",
    transform: "translate(345.25,232.6875)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.38158405 3.57237608 2.82377719 4.79873631 2 9 C-2.49936005 13.83353002 -8.84390501 16.82876318 -15 19 C-15.66 19 -16.32 19 -17 19 C-17 20.32 -17 21.64 -17 23 C-16.40832031 22.83242187 -15.81664062 22.66484375 -15.20703125 22.4921875 C-8.71221756 20.81815722 -8.71221756 20.81815722 -5.0625 21.75 C-3 23 -3 23 -1 25 C-1.14845522 28.41447003 -1.49038073 30.38845687 -3.69921875 33.0390625 C-6.99746156 35.85012853 -10.63646658 37.08793922 -14.63671875 38.65625 C-17.1717417 39.76767748 -17.1717417 39.76767748 -17.83203125 42.15625 C-17.88746094 42.7646875 -17.94289063 43.373125 -18 44 C-17.34773438 43.7834375 -16.69546875 43.566875 -16.0234375 43.34375 C-4.77287929 39.75950137 -4.77287929 39.75950137 0.375 42.0625 C2 44 2 44 2.75 47.3125 C1.932126 51.33371385 1.57415198 51.80321677 -1.5 54.1875 C-2.97815337 55.1590806 -4.47884854 56.09722401 -6 57 C-6.65871094 57.40476562 -7.31742187 57.80953125 -7.99609375 58.2265625 C-12.76510157 60.89413629 -17.50155729 62.27492214 -23 62 C-26.69337234 60.63208432 -29.57824294 59.11943777 -32 56 C-35.51379377 41.17442092 -36.78522772 20.55206307 -29 7 C-22.38382909 -0.21764099 -9.12725253 -2.14758883 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(293,230)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 2 2 2 2.4375 5.3125 C2 9 2 9 0.125 11.5625 C-10.69230769 20 -10.69230769 20 -15 20 C-15.33 21.32 -15.66 22.64 -16 24 C-14.89591797 23.73123047 -14.89591797 23.73123047 -13.76953125 23.45703125 C-5.69982847 21.69811321 -5.69982847 21.69811321 -1.8125 23.375 C-1.214375 23.91125 -0.61625 24.4475 0 25 C-0.06731788 28.36589376 -0.19628653 31.01186502 -2.37890625 33.6953125 C-5.33532698 36.32765132 -8.19669 38.22073589 -11.875 39.6875 C-12.90625 40.120625 -13.9375 40.55375 -15 41 C-16.03192648 44.09577944 -16.20345289 46.56535835 -16.375 49.8125 C-16.73306129 54.65513216 -17.39542448 57.9232731 -20 62 C-24.5181022 62.36633261 -24.5181022 62.36633261 -26.5637207 60.8112793 C-32.3745363 53.48331042 -31.44268363 41.72148615 -31.33618164 32.80737305 C-31.31233396 30.67263641 -31.31567888 28.53913546 -31.32226562 26.40429688 C-31.29620305 19.94475455 -31.16756375 14.17492499 -29 8 C-21.68809492 1.8757429 -9.35133495 -0.85012136 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(174,191)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.582a6e340e165ad445b1be28cb52cb6f.svg";
export { ForwardRef as ReactComponent };